import { render, staticRenderFns } from "./DependenciasABM.vue?vue&type=template&id=362b3de2"
import script from "./DependenciasABM.vue?vue&type=script&lang=js"
export * from "./DependenciasABM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports